<template>
  <!-- Page title -->
  <div class="page-title py-5 bg-custom-gradient">
    <div class="container">
      <div class="d-flex flex-lg-row flex-column align-items-lg-center align-items-start justify-content-between">
        <div><h3 class="text-white fw-bold">الربط مع المنصات</h3></div>
        <form class="search-form">
          <div class="d-flex flex-column flex-lg-row gap-3">
            <div class="position-relative">
              <div class="form-icon start">
                <i class="fa fa-search text-white"></i>
              </div>
              <input type="text" class="form-control bg-transparent text-white border-2 border-white" placeholder="البحث .." />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="container mt-5">
    <Platform :id="1" :title="'ربط لزوم'" :section_title="'الربط مع المنصات'" :icon="require('@/assets/images/zm-02_2x.png')" :icon_width="56" :status="'null'" :subtitle="'عليك فقط التسجيل الدخول بحساب الزوم'" :visibility="true" :hasToggler="false">
      <div class="card platform-card bg-light border flex-row align-items-center border-2 d-flex py-2 px-3 gap-2">
        <img src="@/assets/images/ui-king.jpg" class="user-card-avatar rounded-circle" alt="" />
        <div class="d-flex flex-column">
          <h5 class="fs-6 fw-bold mb-0">Medhat Audah</h5>
          <span class="fs-14px text-secondary">medhataudah@gmail.com</span>
        </div>
        <div class="platform-status text-success d-flex align-items-center ms-auto">
          <div class="svg-icon me-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
              <g id="Group_1297" data-name="Group 1297" transform="translate(-2 -2)">
                <path id="Path_91" data-name="Path 91" d="M12,20a8,8,0,1,0-8-8A8,8,0,0,0,12,20Zm0,2A10,10,0,1,0,2,12,10,10,0,0,0,12,22Z" fill="#58bd7d" fill-rule="evenodd" />
                <path id="Path_92" data-name="Path 92" d="M17.7,9.21l-7.223,7.154L6.342,12.753l1.315-1.507,2.737,2.389,5.9-5.846Z" fill="#58bd7d" fill-rule="evenodd" />
              </g>
            </svg>
          </div>
          <span class="fw-bold fs-14px">مفعل</span>
        </div>
      </div>
      <div class="">
        <button class="btn text-danger text-decoration-underline fs-14px">إزالة ربط الحساب</button>
      </div>
    </Platform>
    <Platform :id="2" :title="'ربط لجوجل ميت'" :section_title="'null'" :icon="require('@/assets/images/MaskGroup1_2x.png')" :icon_width="34" :status="'null'" :subtitle="'عليك التسجيل الدخول لجوجل'" :visibility="true" :hasToggler="false">
      <div class="">
        <button class="btn btn-outline-primary rounded-pill px-4 py-2">ربط الحساب</button>
      </div>
    </Platform>
    <Platform :id="3" :title="'ربط لجوجل كاليندر'" :section_title="''" :icon="require('@/assets/images/Google_Calendar.max-1100x1100.svg')" :icon_width="34" :status="'null'" :subtitle="'عليك فقط التسجيل بحساب جوجل'" :visibility="true" :hasToggler="false">
      <div class="card platform-card bg-light border flex-row align-items-center border-2 d-flex py-2 px-3 gap-2">
        <img src="@/assets/images/ui-king.jpg" class="user-card-avatar rounded-circle" alt="" />
        <div class="d-flex flex-column">
          <h5 class="fs-6 fw-bold mb-0">Medhat Audah</h5>
          <span class="fs-14px text-secondary">medhataudah@gmail.com</span>
        </div>
        <div class="platform-status text-success d-flex align-items-center ms-auto">
          <div class="svg-icon me-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
              <g id="Group_1297" data-name="Group 1297" transform="translate(-2 -2)">
                <path id="Path_91" data-name="Path 91" d="M12,20a8,8,0,1,0-8-8A8,8,0,0,0,12,20Zm0,2A10,10,0,1,0,2,12,10,10,0,0,0,12,22Z" fill="#58bd7d" fill-rule="evenodd" />
                <path id="Path_92" data-name="Path 92" d="M17.7,9.21l-7.223,7.154L6.342,12.753l1.315-1.507,2.737,2.389,5.9-5.846Z" fill="#58bd7d" fill-rule="evenodd" />
              </g>
            </svg>
          </div>
          <span class="fw-bold fs-14px">مفعل</span>
        </div>
      </div>
      <div class="">
        <button class="btn text-danger text-decoration-underline fs-14px">إزالة ربط الحساب</button>
      </div>
    </Platform>
  </div>
</template>

<script>
import Platform from '../components/Platform.vue'
export default {
  components: {Platform},
  name: 'Platforms',
  setup() {},
}
</script>

<style>
</style>